// @ts-nocheck
// chat rooms...
export const GROUP_CHAT_ROOMS_LOADING = "GROUP_CHAT_ROOMS_LOADING";
export const GROUP_CHAT_ROOMS_SUCCESS = "GROUP_CHAT_ROOMS_SUCCESS";
export const GROUP_CHAT_ROOMS_FAILURE = "GROUP_CHAT_ROOMS_FAILURE";
export const ON_SELECT_NEW_CHAT_ROOM_GROUP_CHAT =
  "ON_SELECT_NEW_CHAT_ROOM_GROUP_CHAT";
export const ADD_NEW_CHAT_ROOM_GROUP_CHAT_LOADING =
  "ADD_NEW_CHAT_ROOM_GROUP_CHAT_LOADING";
export const ADD_NEW_CHAT_ROOM_GROUP_CHAT_SUCCESS =
  "ADD_NEW_CHAT_ROOM_GROUP_CHAT_SUCCESS";
export const ADD_NEW_CHAT_ROOM_GROUP_CHAT_FAILURE =
  "ADD_NEW_CHAT_ROOM_GROUP_CHAT_FAILURE";
4;
export const EDIT_CHAT_ROOM_GROUP_CHAT_LOADING =
  "EDIT_CHAT_ROOM_GROUP_CHAT_LOADING";
export const EDIT_CHAT_ROOM_GROUP_CHAT_SUCCESS =
  "EDIT_CHAT_ROOM_GROUP_CHAT_SUCCESS";
export const EDIT_CHAT_ROOM_GROUP_CHAT_FAILURE =
  "EDIT_CHAT_ROOM_GROUP_CHAT_FAILURE";
export const ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE_GROUP_CHAT =
  "ADD_NEW_CHAT_ROOM_PARTICIPANT_SIDE_GROUP_CHAT";
export const UPDATE_GROUP_CHAT = "UPDATE_GROUP_CHAT";
export const UPDATE_GROUP_CHAT_STATUS_LOADING =
  "UPDATE_GROUP_CHAT_STATUS_LOADING";
export const UPDATE_GROUP_CHAT_STATUS_SUCCESS =
  "UPDATE_GROUP_CHAT_STATUS_SUCCESS";
export const UPDATE_GROUP_CHAT_STATUS_FAILURE =
  "UPDATE_GROUP_CHAT_STATUS_FAILURE";
export const ADDED_TO_GROUP_CHAT = "ADDED_TO_GROUP_CHAT";
export const REMOVED_FROM_GROUP_CHAT = "REMOVED_FROM_GROUP_CHAT";
export const UPDATE_POST_COLLAPSE_MESSAGES = "UPDATE_POST_COLLAPSE_MESSAGES";
// chat rooms...

// new post...
export const CREATE_NEW_POST_LOADING = "CREATE_NEW_POST_LOADING";
export const CREATE_NEW_POST_SUCCESS = "CREATE_NEW_POST_SUCCESS";
export const CREATE_NEW_POST_FAILURE = "CREATE_NEW_POST_FAILURE";
// new post...

// chat room messages...
export const SEND_NEW_MESSAGE_LOADING_GROUP_CHAT =
  "SEND_NEW_MESSAGE_LOADING_GROUP_CHAT";
export const SEND_NEW_MESSAGE_SUCCESS_GROUP_CHAT =
  "SEND_NEW_MESSAGE_SUCCESS_GROUP_CHAT";
export const SEND_NEW_MESSAGE_FAILURE_GROUP_CHAT =
  "SEND_NEW_MESSAGE_FAILURE_GROUP_CHAT";
export const ON_NEW_MESSAGE_GROUP_CHAT = "ON_NEW_MESSAGE_GROUP_CHAT";
export const FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_LOADING =
  "FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_LOADING";
export const FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_SUCCESS =
  "FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_SUCCESS";
export const FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_FAILURE =
  "FETCH_CHAT_ROOM_MESSAGES_GROUP_CHAT_FAILURE";
export const ON_EDIT_MESSAGE_GROUP_CHAT = "ON_EDIT_MESSAGE_GROUP_CHAT";
export const ON_DELETE_MESSAGE_GROUP_CHAT = "ON_DELETE_MESSAGE_GROUP_CHAT";
export const ON_MARK_MESSAGES_AS_READ_GROUP_CHAT =
  "ON_MARK_MESSAGES_AS_READ_GROUP_CHAT";
export const SET_UNREAD_CHAT_ROOMS_COUNT_LOADING =
  "SET_UNREAD_CHAT_ROOMS_COUNT_LOADING";
export const SET_UNREAD_GROUP_CHAT_ROOMS_COUNT =
  "SET_UNREAD_GROUP_CHAT_ROOMS_COUNT";
export const SET_UNREAD_CHAT_ROOMS_COUNT_FAILURE =
  "SET_UNREAD_CHAT_ROOMS_COUNT_FAILURE";
// chat room messages...

// edit message...
export const EDIT_NEW_MESSAGE_GROUP_CHAT_LOADING =
  "EDIT_NEW_MESSAGE_GROUP_CHAT_LOADING";
export const EDIT_NEW_MESSAGE_GROUP_CHAT_SUCCESS =
  "EDIT_NEW_MESSAGE_GROUP_CHAT_SUCCESS";
export const EDIT_NEW_MESSAGE_GROUP_CHAT_FAILURE =
  "EDIT_NEW_MESSAGE_GROUP_CHAT_FAILURE";
// edit message...

// top N events...
export const TOP_N_EVENTS_LOADING = "TOP_N_EVENTS_LOADING";
export const TOP_N_EVENTS_SUCCESS = "TOP_N_EVENTS_SUCCESS";
export const TOP_N_EVENTS_FAILURE = "TOP_N_EVENTS_FAILURE";
// top N events...

// reset slice...
export const RESET_GROUP_CHAT_SLICE = "RESET_GROUP_CHAT_SLICE";
// reset slice...

// get navbar count
export const GET_UNREAD_MESSAGES_REQUEST = "GET_UNREAD_MESSAGES_REQUEST";
export const GET_UNREAD_MESSAGES_SUCCESS = "GET_UNREAD_MESSAGES_SUCCESS";
export const GET_UNREAD_MESSAGES_FAILURE = "GET_UNREAD_MESSAGES_FAILURE";
//

// get message information
export const GET_MESSAGE_PARTICIPANT_STATUS_REQUEST =
  "GET_MESSAGE_PARTICIPANT_STATUS_REQUEST";
export const GET_MESSAGE_PARTICIPANT_STATUS_FAILURE =
  "GET_MESSAGE_PARTICIPANT_STATUS_FAILURE";
export const GET_MESSAGE_PARTICIPANT_STATUS_SUCCESS =
  "GET_MESSAGE_PARTICIPANT_STATUS_SUCCESS";